import { useCallback, useEffect, useState } from "react";
import { api } from "./api.js";

/** Lädt eine Ressource und stellt einen reload() bereit. Bewusst klein gehalten. */
export function useApi<T>(path: string | null) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!path) { setLoading(false); return; }
    setLoading(true);
    try {
      setData(await api.get<T>(path));
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Unbekannter Fehler");
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => { void load(); }, [load]);

  return { data, error, loading, reload: load };
}
